// LAZY LOADING
var lazyLoadInstance = new LazyLoad({});
lazyLoadInstance.update()

// CHECK PRODUCT AVAILABILITY AND DISABLE BUTTON IF UNAVAILABLE
function checkProductAvailability() {
  let buyBtn = document.querySelectorAll('[data-add-to-cart]')
  buyBtn.forEach(btn => {
    const productAvailable = btn.getAttribute('data-product-available')
    if (productAvailable === 'false') {
      btn.classList.add('disabled')
      btn.setAttribute('disabled', '')
      btn.style.pointerEvents = 'none'
      btn.textContent = 'SOLD OUT'
    }
  })
}

// Initialize availability check on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', checkProductAvailability)
} else {
  // DOM is already loaded
  checkProductAvailability()
}

let buyBtn = document.querySelectorAll('[data-add-to-cart]')
buyBtn.forEach(btn => {
    btn.addEventListener('click',() => {
        // 商品が利用不可の場合は処理を中断
        if (btn.hasAttribute('disabled') || btn.classList.contains('disabled')) {
            return
        }
        
        let form = btn.parentElement
        let tempar = []
    
        //OPTION
     
        let repairOption = form.querySelectorAll('.repairOptions:checked')
        if(repairOption.length > 0) {
            repairOption.forEach(op => tempar.push(op.value) );
            form.querySelector('.repair-option').value = tempar.join(',')
        }

        //USAGE
        let repairUsage = form.querySelectorAll('.repairUsage:checked')
        if(repairUsage.length > 0){
            tempar = []
            
            repairUsage.forEach(ru => {
                tempar.push(ru.value)
            });
            form.querySelector('.repair-usage').value = tempar.join(',')   
        }

        //PROBLEMS
        tempar = []
        let repairProblems = form.querySelectorAll('.repairProblems')
        if(repairProblems.length > 0) {
            repairProblems.forEach(rp => {

                if(rp.checked && rp.id !== 'problem12'){
                    tempar.push(rp.value)
                    console.log(rp.name)
                }

                if(rp.type == 'text' && rp.value !== '')
                    tempar.push(rp.value)
            });
        
            form.querySelector('.repair-problem').value = tempar.join(',') 
        }
        form.submit()
    })
});



//QUANTITY MULTIPLIER 
let quantitySelector = document.querySelectorAll('[data-quantity-selector]')
let productPrice = document.querySelectorAll('[data-product-price]')

function multiplyPricing(value){ // Update All Product Price ea. Y1000
    productPrice.forEach(el =>  el.innerHTML = formatter.format((el.dataset.productPrice / 100 ) * value) )
}
  
quantitySelector.forEach(selector =>{ 
    selector.addEventListener('change', function(){
      multiplyPricing(selector.value)
    })
})


